<div class="career-path-licenses-component" *ngIf="licencias.length && isLicenseListValid">
    <div class="item-title">{{ 'publicProfiles.careerPath.licences' | translate:locale.language }}</div>
    <span class="item-description">
        <div class="item" *ngFor="let item of licencias">
            <span class="title" *ngIf="item.TipoLicencia"> Tipo: {{item.TipoLicencia}} </span> <br *ngIf="item.TipoLicencia" />
            <span class="subtitle" *ngIf="item.Nombre"> {{item.Nombre}} </span> <br *ngIf="item.Nombre" />
            <span class="subtitle" *ngIf="item.Especialidad"> {{item.Especialidad}} </span> <br *ngIf="item.Especialidad" />
            <span class="subtitle">
                {{licencia}}
            </span>
        </div>
    </span>
</div>